export const portfolioConstants = {
  MY_PORTFOLIO_ACCOUNT_SUMMARY_REQUEST: "MY_PORTFOLIO_ACCOUNT_SUMMARY_REQUEST",
  MY_PORTFOLIO_ACCOUNT_SUMMARY_COMPLETE:
    "MY_PORTFOLIO_ACCOUNT_SUMMARY_COMPLETE",
  MY_PORTFOLIO_ACCOUNT_SUMMARY_ERROR: "MY_PORTFOLIO_ACCOUNT_SUMMARY_ERROR",

  ASSETS_TYPE: "ASSETS",
  LIABILITIES_TYPE: "LIABILITIES",

  ASSETS_SUMMERY: "ASSETS_SUMMERY",
  LIABILITY_SUMMERY: "LIABILITY_SUMMERY",
  FIXED_DEPOSIT_SUMMERY: "FIXED_DEPOSIT_SUMMERY",
  SAVING_SUMMERY: "SAVING_SUMMERY",
  CURRENT_SUMMERY: "CURRENT_SUMMERY",
  LOAN_SUMMERY: "LOAN_SUMMERY",
  CREDIT_CARD_SUMMERY: "CREDIT_CARD_SUMMERY",

  SAVING_ACCOUNT_TYPE: "SAVING",
  CURRENT_ACCOUNT_TYPE: "CURRENT",
  LOAN_ACCOUNT_TYPE: "LOAN",
  CREDIT_ACCOUNT_TYPE: "CREDIT",
  FIXED_DEPOSIT_ACCOUNT_TYPE: "DEPOSITS",
  LENDING_ACCOUNT_TYPE: "LENDING",

  SAVING: "Savings Accounts",
  CURRENT: "Current Accounts",
  DEPOSITS: "Fixed Deposits",
  CREDIT: "Credit Cards",
  LOAN: "Loans",
  LENDING: "Loans",
  LEASE: "Leases",
  CLEAR_PORTFOLIO_DATA: "CLEAR_PORTFOLIO_DATA",
};
